// Hogarth users are covered too: the auth layer rewrites @hogarth.com to @wppproduction.com upstream.
export const VIEW_ALL_ELIGIBLE_DOMAINS: readonly string[] = ["wppproduction.com", "wpp.com"];

export const isViewAllEligibleEmail = (email?: string | null): boolean => {
    if (!email) {
        return false;
    }

    const domain = email.toLowerCase().split("@")[1];

    return !!domain && VIEW_ALL_ELIGIBLE_DOMAINS.includes(domain);
};
